// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
export type PresentationViewSource_EntityFragment = { __typename?: 'Entity', id: string, onboardingEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null, viewSourceDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, document: { __typename?: 'Document', id: string } } | null } | null> | null } };

export type PresentationViewSource_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, onboardedIndividualSuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null };

export type PresentationViewSource_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, onboardedOrganizationSuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null };

export type PresentationViewSource_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, onboardingTestamentaryEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null };

export const Operations = {
  Fragment: {
    PresentationViewSource_Entity: 'PresentationViewSource_Entity' as const,
    PresentationViewSource_ClientProfile: 'PresentationViewSource_ClientProfile' as const,
    PresentationViewSource_ClientOrganization: 'PresentationViewSource_ClientOrganization' as const,
    PresentationViewSource_TestamentaryEntity: 'PresentationViewSource_TestamentaryEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PresentationViewSource_EntityFragmentDoc = gql`
    fragment PresentationViewSource_Entity on Entity {
  id
  onboardingEntitySuggestion {
    id
  }
  viewSourceDocumentRelationships: entityDocumentRelationships {
    edges {
      node {
        id
        document {
          id
        }
      }
    }
  }
}
    `;
export const PresentationViewSource_ClientProfileFragmentDoc = gql`
    fragment PresentationViewSource_ClientProfile on ClientProfile {
  id
  onboardedIndividualSuggestion {
    id
  }
}
    `;
export const PresentationViewSource_ClientOrganizationFragmentDoc = gql`
    fragment PresentationViewSource_ClientOrganization on ClientOrganization {
  id
  onboardedOrganizationSuggestion {
    id
  }
}
    `;
export const PresentationViewSource_TestamentaryEntityFragmentDoc = gql`
    fragment PresentationViewSource_TestamentaryEntity on TestamentaryEntity {
  id
  onboardingTestamentaryEntitySuggestion {
    id
  }
}
    `;